import { render } from "./Redirect.vue?vue&type=template&id=27c2e88a&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"

import "./Redirect.vue?vue&type=style&index=0&id=27c2e88a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c2e88a"]])

export default __exports__